import { useState } from 'react';
import { URGENCIES, type Approval, type ApprovalStatus } from './sample';

/** Which status tab, search words and filters are chosen, and the cards that match them */
export function useApprovalFilters(items: Approval[]) {
  const [status, setStatus] = useState<ApprovalStatus>('pending');
  const [search, setSearch] = useState('');
  const [kind, setKind] = useState('all');
  const [urgency, setUrgency] = useState('all');
  const [sort, setSort] = useState('urgent');

  const q = search.trim().toLowerCase();
  const shown = items
    .filter((a) => a.status === status)
    .filter((a) => kind === 'all' || a.kind === kind)
    .filter((a) => urgency === 'all' || a.urgency === urgency)
    .filter((a) => !q || [a.srb, a.title, a.subtitle, a.summary, a.to ?? ''].join(' ').toLowerCase().includes(q));
  if (sort === 'urgent') shown.sort((a, b) => URGENCIES.indexOf(a.urgency) - URGENCIES.indexOf(b.urgency));
  // urgent ones always stay on top, whichever way the rest is sorted (sort is stable, so the order below them is kept)
  else shown.sort((a, b) => Number(b.urgency === 'High') - Number(a.urgency === 'High'));

  return { status, setStatus, search, setSearch, kind, setKind, urgency, setUrgency, sort, setSort, shown };
}

export type ApprovalFilters = ReturnType<typeof useApprovalFilters>;
